import { render, staticRenderFns } from "./AddMoreRecipient.vue?vue&type=template&id=f51fb908"
import script from "./AddMoreRecipient.vue?vue&type=script&lang=js"
export * from "./AddMoreRecipient.vue?vue&type=script&lang=js"
import style0 from "./AddMoreRecipient.vue?vue&type=style&index=0&id=f51fb908&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports